// Brass Eye fix: the first swatch click after a page load doesn't move the gallery.
// Horizon swaps in a brand new media-gallery on that first change, and the new
// slideshow's attributeChangedCallback runs before its scroller exists, so it bails.
// Every change after that updates the existing element in place and works fine.
// This re-checks the position after a variant change and corrects it if it's off.
(function () {
  if (window.__brassEyeGallerySlideFix) return;
  window.__brassEyeGallerySlideFix = true;

  function enforce() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return false;

    var slideshow = gallery.querySelector('slideshow-component');
    var slides = gallery.querySelector('slideshow-slides');
    if (!slideshow || !slides) return false;

    var index = parseInt(slideshow.getAttribute('initial-slide') || '0', 10);
    var target = slides.children[index];
    if (!target) return false;

    if (Math.abs(slides.scrollLeft - target.offsetLeft) < 8) return true;
    slides.scrollLeft = target.offsetLeft;
    return false;
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.closest('variant-picker')) return;
    var ticks = 0;
    var timer = setInterval(function () {
      ticks++;
      if (enforce() || ticks > 16) clearInterval(timer);
    }, 120);
  }, true);
})();